export const TabletBreakpoint = 1200;
export const MobileBreakpoint = 767;
export const SymbolRouteParameter = 'symbol';
export const SymbolRouteParameterPart = ':symbol';
export const ErrorMessageIdSelector = 'id';
export const GetServerDataFailedErrorKey = 'ERRORS_GET_SERVER_DATA_FAILED';
export const InternalServerErrorKey = 'COMMON.ERRORS_INTERNAL_SERVER';
export const SomethingWentWrongErrorKey = 'COMMON.ERRORS_SOMETHING_WENT_WRONG';
export const UnauthorisedErrorKey = 'COMMON.ERRORS_UNAUTHORISED';
export const BadRequestErrorKey = 'COMMON.ERRORS_BAD_REQUEST';
export const UnknownErrorKey = 'COMMON.ERRORS_UNKNOWN_ERROR';
export const UpdateDetailsFailedErrorKey = 'COMMON.ERRORS_UPDATE_DETAILS_FAILED';
export const FetchDetailsFailedErrorKey = 'COMMON.ERRORS_FAILED_FETCH_DATA';
export const UploadFileFailedErrorKey = 'COMMON.ERRORS_FAILED_UPLOAD_FILE';
export const RegisterFileFailedErrorKey = 'COMMON.ERRORS_FAILED_REGISTER_FILE';
export const UpdateDocumentFailedErrorKey = 'COMMON.ERRORS_FAILED_UPDATE_DOCUMENT';
export const GetFileFailedErrorKey = 'COMMON.ERRORS_GET_FILE_FAILED';
export const RegisterButtonKey = 'COMMON.BUTTON_REGISTER';
export const NextButtonKey = 'COMMON.BUTTON_NEXT';
export const TransparentImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
export const FundPortalTradingPlatformId = 99;
